module.exports = __webpack_public_path__ + "static/media/desktop-frame-about-2.03c58d92.png";